import Vuex from 'vuex';

const state = {
  show: false,
  showReadMore: false,
  showSpecificationList: false
};

const getters = {
  showReadMoreText: state => state.show,
  showReadMore: state => state.showReadMore,
  showSpecificationList: state => state.showSpecificationList
};

const actions = {
  toggleReadMoreText: ({ state, commit }) => {
    commit('toggleReadMoreShowState', { show: !state.show })
  },
  updateShowReadMore: ({ state, commit }, show) => {
    commit('changeShowReadMore', { show })
  },
  toggleSpecificationList: ({ state, commit }) => {
    commit('changeShowSpecificationList')
  }
};

const mutations = {
  toggleReadMoreShowState: (state, { show }) => {
    state.show = show
  },
  changeShowReadMore: (state, { show }) => {
    state.showReadMore = show
  },
  changeShowSpecificationList: (state) => {
    state.showSpecificationList = !state.showSpecificationList;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./store/modules/readmore.js